// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import SignupModal from '../components/SignupModal';
// import { Button } from '../components/ui/button';
// import { Input } from '../components/ui/input';
// import { Textarea } from '../components/ui/textarea';
// import { toast } from '../hooks/use-toast';
// import { Toaster } from '../components/ui/toaster';
// import { Mail, Phone, MapPin, Clock, Send, MessageSquare, Headphones } from 'lucide-react';

// const ContactUs = () => {
//   const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     company: '',
//     phone: '',
//     subject: '',
//     message: '',
//     agreeToTerms: false,
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // ... inside your ContactUs component

// const handleChange = (e) => {
//   const { name, value, type, checked } = e.target;
//   setFormData({
//     ...formData,
//     [name]: type === 'checkbox' ? checked : value,
//   });
// };

// const handleSubmit = async (e) => {
//   e.preventDefault();

//   // 1. Check for terms agreement
//   if (!formData.agreeToTerms) {
//     toast({
//       title: "Agreement Required",
//       description: "Please agree to our Privacy Policy and Terms of Service to continue.",
//       variant: "destructive",
//     });
//     return;
//   }

//   setIsSubmitting(true);

//   try {
//     // 2. Use actual FormData to match your PHP backend requirements
//     const formBody = new FormData();
//     Object.entries(formData).forEach(([key, value]) => {
//       // Don't need to send the boolean 'agreeToTerms' to the server unless requested
//       if (key !== 'agreeToTerms') {
//         formBody.append(key, value);
//       }
//     });

//     const response = await fetch("https://aalign.io/send-mail.php", {
//       method: "POST",
//       body: formBody,
//     });

//     const result = await response.json();

//     if (result.success) {
//       toast({
//         title: "Message sent successfully!",
//         description: "Our team will get back to you within 24 hours.",
//       });
//       // Reset form including the checkbox
//       setFormData({ 
//         name: '', email: '', company: '', phone: '', 
//         subject: '', message: '', agreeToTerms: false 
//       });
//     } else {
//       toast({
//         title: "Error",
//         description: result.message || "Something went wrong.",
//         variant: "destructive",
//       });
//     }
//   } catch (error) {
//     toast({
//       title: "Network Error",
//       description: "Unable to connect to the server. Please try again later.",
//       variant: "destructive",
//     });
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   const contactInfo = [
//     {
//       icon: Mail,
//       title: 'Email Us',
//       details: 'support@aalign.io',
//       subtext: 'We respond within 24 hours',
//       link: 'mailto:support@aalign.io',
//       color: 'blue',
//     },
//     {
//       icon: Phone,
//       title: 'Call Us',
//       details: '+1 321-999-7374',
//       subtext: 'Mon-Fri, 9 AM - 6 PM (UK time)',
//       link: 'tel:+13219997374',
//       color: 'green',
//     },
//     {
//       icon: MapPin,
//       title: 'Visit Our Office',
//       details: '20-22 Wenlock Rd',
//       subtext: 'London N1 7GU, United Kingdom',
//       link: 'https://maps.google.com/?q=20-22+Wenlock+Rd,+London+N1+7GU,+United+Kingdom',
//       color: 'orange',
//     },
//   ];

//   const supportOptions = [
//     {
//       icon: MessageSquare,
//       title: 'Live Chat',
//       description: 'Get instant help from our support team',
//       availability: 'Available Now',
//       buttonText: 'Start Chat',
//       color: 'from-blue-500 to-cyan-600',
//     },
//     {
//       icon: Headphones,
//       title: 'Schedule a Call',
//       description: 'Book a time with our product experts',
//       availability: 'Next Available: Today',
//       buttonText: 'Book Now',
//       color: 'from-purple-500 to-pink-600',
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-white">
//       <Header />
//       <Toaster />

//       {/* Hero Section */}
//       <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-orange-50 via-white to-red-50 relative overflow-hidden">
//         <div className="absolute top-20 right-10 w-72 h-72 bg-orange-200/20 rounded-full blur-3xl animate-pulse"></div>
//         <div className="absolute bottom-10 left-10 w-96 h-96 bg-red-200/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        
//         <div className="max-w-7xl mx-auto text-center relative z-10">
//           <h1 className="text-5xl lg:text-7xl font-black mb-8"> 
//             Customer Success Stories
//           </h1>
//           <p className="text-xl lg:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
//             See how businesses across industries have transformed their lead management and achieved remarkable results with AALIGN.
//           </p>
//         </div>
//       </section>

//       {/* Contact Info Cards */}
//       <section className="py-12 px-6 -mt-8 relative z-20">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid md:grid-cols-3 gap-6">
//             {contactInfo.map((info, idx) => {
//               const Icon = info.icon;
//               const colorMap = {
//                 blue: 'from-blue-500 to-cyan-600',
//                 green: 'from-green-500 to-emerald-600',
//                 orange: 'from-orange-500 to-red-600',
//               };
//               return (
//                 <a
//                   key={idx}
//                   href={info.link}
//                   className="group p-8 rounded-2xl bg-white border-2 border-gray-100 hover:border-orange-300 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
//                 >
//                   <div className={`w-16 h-16 bg-gradient-to-br ${colorMap[info.color]} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
//                     <Icon className="w-8 h-8 text-white" />
//                   </div>
//                   <h3 className="text-xl font-bold mb-2 text-gray-900">{info.title}</h3>
//                   <p className="text-lg font-semibold text-gray-800 mb-1">{info.details}</p>
//                   <p className="text-sm text-gray-600">{info.subtext}</p>
//                 </a>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Main Contact Form Section */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid lg:grid-cols-2 gap-16 items-start">
//             {/* Left Content */}
//             <div className="space-y-8">
//               <div>
//                 <div className="inline-block mb-6">
//                   <div className="bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold">
//                     CONTACT FORM
//                   </div>
//                 </div>
//                 <h2 className="text-4xl lg:text-5xl font-black leading-tight mb-6">
//                   Send Us a
//                   <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-600"> Message</span>
//                 </h2>
//                 <p className="text-lg text-gray-600 leading-relaxed mb-8">
//                   Fill out the form and our team will get back to you within 24 hours. We're here to answer questions about features, pricing, integrations, or anything else.
//                 </p>
//               </div>

//               {/* Office Hours */}
//               <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl border-2 border-blue-100">
//                 <div className="flex items-center gap-4 mb-4">
//                   <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
//                     <Clock className="w-6 h-6 text-white" />
//                   </div>
//                   <h3 className="text-xl font-bold text-gray-900">Office Hours</h3>
//                 </div>
//                 <div className="space-y-2 text-gray-700">
//                   <p><strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM (UK time)</p>
//                   <p><strong>Saturday:</strong> 10:00 AM - 2:00 PM (UK time)</p>
//                   <p><strong>Sunday:</strong> Closed</p>
//                 </div>
//               </div>

//               {/* Support Options */}
//               <div className="space-y-4">
//                 <h3 className="text-2xl font-bold text-gray-900 mb-4">Other Ways to Reach Us</h3>
//                 {supportOptions.map((option, idx) => {
//                   const Icon = option.icon;
//                   return (
//                     <div key={idx} className="p-6 bg-white rounded-2xl border-2 border-gray-100 hover:border-orange-200 hover:shadow-lg transition-all">
//                       <div className="flex items-start gap-4">
//                         <div className={`w-14 h-14 bg-gradient-to-br ${option.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
//                           <Icon className="w-7 h-7 text-white" />
//                         </div>
//                         <div className="flex-1">
//                           <h4 className="text-xl font-bold text-gray-900 mb-2">{option.title}</h4>
//                           <p className="text-gray-600 mb-3">{option.description}</p>
//                           <div className="flex items-center justify-between">
//                             <span className="text-sm text-green-600 font-semibold">{option.availability}</span>
//                             <Button className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-2 rounded-lg text-sm font-semibold">
//                               {option.buttonText}
//                             </Button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* Right Content - Form */}
//             <div className="bg-white rounded-3xl shadow-2xl p-8 lg:p-10 border-2 border-gray-100 sticky top-32">
//               <form onSubmit={handleSubmit} className="space-y-6">
//                 <div className="grid md:grid-cols-2 gap-6">
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Full Name *
//                     </label>
//                     <Input
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       required
//                       placeholder="John Doe"
//                       className="w-full px-4 py-3 rounded-xl border-gray-300 focus:border-orange-500 focus:ring-orange-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Email Address *
//                     </label>
//                     <Input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                       placeholder="john@company.com"
//                       className="w-full px-4 py-3 rounded-xl border-gray-300 focus:border-orange-500 focus:ring-orange-500"
//                     />
//                   </div>
//                 </div>
                
//                 <div className="grid md:grid-cols-2 gap-6">
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Company Name
//                     </label>
//                     <Input
//                       type="text"
//                       name="company"
//                       value={formData.company}
//                       onChange={handleChange}
//                       placeholder="Your Company"
//                       className="w-full px-4 py-3 rounded-xl border-gray-300 focus:border-orange-500 focus:ring-orange-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Phone Number
//                     </label>
//                     <Input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       placeholder="+1 (555) 000-0000"
//                       className="w-full px-4 py-3 rounded-xl border-gray-300 focus:border-orange-500 focus:ring-orange-500"
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Subject *
//                   </label>
//                   <Input
//                     type="text"
//                     name="subject"
//                     value={formData.subject}
//                     onChange={handleChange}
//                     required
//                     placeholder="How can we help you?"
//                     className="w-full px-4 py-3 rounded-xl border-gray-300 focus:border-orange-500 focus:ring-orange-500"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">
//                     Message *
//                   </label>
//                   <Textarea
//                     name="message"
//                     value={formData.message}
//                     onChange={handleChange}
//                     required
//                     rows={6}
//                     placeholder="Tell us more about your needs..."
//                     className="w-full px-4 py-3 rounded-xl border-gray-300 focus:border-orange-500 focus:ring-orange-500"
//                   />
//                 </div>

//                 {/* Terms and Conditions Checkbox */}
//                 <div className="flex items-start gap-2" style={{ alignItems: 'center' }}>
//                   <input
//   type="checkbox"
//   name="agreeToTerms" // This must match the key in your formData state
//   checked={formData.agreeToTerms}
//   onChange={handleChange}
//   required
//   className="..."
// />
//                   <label className="text-sm text-gray-600">
//                     By submitting this form, you agree to our{' '}
//                     <Link to="/privacy-policy" className="text-orange-600 hover:text-orange-700 font-semibold">
//                       Privacy Policy
//                     </Link>{' '}
//                     and{' '}
//                     <Link to="/terms-and-conditions" className="text-orange-600 hover:text-orange-700 font-semibold">
//                       Terms of Service
//                     </Link>
//                     .
//                   </label>
//                 </div>

//                 <Button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   {isSubmitting ? (
//                     <span className="flex items-center justify-center gap-2">
//                       <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                       Sending...
//                     </span>
//                   ) : (
//                     <>
//                       Send Message
//                       <Send className="ml-2 w-5 h-5" />
//                     </>
//                   )}
//                 </Button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* FAQ Section */}
//       <section className="py-20 px-6 bg-gradient-to-b from-white to-orange-50/20">
//         <div className="max-w-4xl mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl lg:text-5xl font-black mb-4">Frequently Asked Questions</h2>
//             <p className="text-xl text-gray-600">Quick answers to common questions</p>
//           </div>
//           <div className="space-y-6">
//             <div className="p-6 bg-white rounded-2xl border-2 border-gray-100 hover:border-orange-200 transition-all">
//               <h3 className="font-bold text-lg mb-2 text-gray-900">How quickly will I get a response?</h3>
//               <p className="text-gray-600">We typically respond to all inquiries within 24 hours during business days. For urgent matters, use our live chat feature for immediate assistance.</p>
//             </div>
//             <div className="p-6 bg-white rounded-2xl border-2 border-gray-100 hover:border-orange-200 transition-all">
//               <h3 className="font-bold text-lg mb-2 text-gray-900">Can I schedule a product demo?</h3>
//               <p className="text-gray-600">Yes! Simply mention it in your message or click the "Schedule a Call" button above to book a personalized demo with our product experts.</p>
//             </div>
//             <div className="p-6 bg-white rounded-2xl border-2 border-gray-100 hover:border-orange-200 transition-all">
//               <h3 className="font-bold text-lg mb-2 text-gray-900">Do you offer technical support?</h3>
//               <p className="text-gray-600">Absolutely! Our technical support team is available for all customers. Premium and Enterprise plans include priority support with faster response times.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-24 px-6 bg-gradient-to-r from-orange-500 to-red-600 text-white">
//         <div className="max-w-4xl mx-auto text-center">
//           <h2 className="text-4xl lg:text-5xl font-black mb-6">
//             Ready to Transform Your Lead Management?
//           </h2>
//           <p className="text-xl text-orange-100 mb-10">
//             Join 300+ businesses already growing with AALIGN
//           </p>
//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <Button 
//               onClick={() => setIsSignupModalOpen(true)}
//               className="bg-white text-orange-600 hover:bg-gray-100 font-bold px-12 py-4 rounded-xl shadow-2xl transition-all transform hover:scale-105"
//             >
//               Start Free Trial
//             </Button>
//             <Button
//               variant="outline"
//               className="border-2 border-white text-white hover:bg-white/10 font-bold px-12 py-4 rounded-xl transition-all"
//             >
//               View Pricing
//             </Button>
//           </div>
//         </div>
//       </section>

//       <Footer />
      
//       {/* Signup Modal */}
//       <SignupModal isOpen={isSignupModalOpen} onClose={() => setIsSignupModalOpen(false)} />
//     </div>
//   );
// };

// export default ContactUs;

import React from "react";
import { Link } from 'react-router-dom';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { TrendingUp, Clock, Target, Quote } from "lucide-react";

const CaseStudies = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 bg-gradient-to-br from-orange-50 via-white to-red-50">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl lg:text-5xl font-black mb-6">
            Customer Success Stories
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how businesses across industries have transformed their lead
            management and achieved remarkable results with AALIGN.
          </p>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="py-12 px-6 bg-gradient-to-r from-orange-500 to-red-600">
        <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 text-center text-white">
          <Stat value="340%" label="Average Conversion Increase" />
          <Stat value="25+ hrs" label="Weekly Time Saved" />
          <Stat value="99.9%" label="Data Accuracy Rate" />
          <Stat value="5x" label="Average ROI Improvement" />
        </div>
      </section>

      {/* Case Study */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto space-y-24">

          {/* Case Study Card */}
          <CaseStudy
            tag="B2B SaaS"
            title="How a Growing SaaS Company Increased Lead Conversions by 340%"
            image="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200"
            stats={[
              { icon: TrendingUp, value: "340%", label: "Increase in Conversions" },
              { icon: Clock, value: "25 hrs", label: "Time Saved Weekly" },
              { icon: Target, value: "+85%", label: "Lead Quality Score" },
            ]}
            challenge="Processing 5,000+ leads monthly with only a 2% conversion rate. Sales teams were overwhelmed by low-quality leads."
            solution="AALIGN’s AI-powered lead scoring and automated validation prioritized high-intent prospects and integrated seamlessly with their CRM."
            results={[
              "Conversion rate increased from 2% to 8.8%",
              "Sales productivity improved by 156%",
              "Cost per acquisition reduced by 62%",
              "Lead response time reduced to 15 minutes",
            ]}
            quote="AALIGN completely transformed how we approach lead management. Our sales team now focuses only on leads ready to buy."
            author="VP of Sales"
          />

        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 bg-gradient-to-r from-orange-500 to-red-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Ready to Write Your Success Story?
          </h2>
          <p className="text-xl text-orange-100 mb-8">
            Join hundreds of businesses transforming lead management with AALIGN.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button className="bg-white text-orange-600 font-bold px-10 py-4 rounded-xl">
              Get Started Today
            </Button>
            <Button variant="outline" className="border-white text-white px-10 py-4">
              View Pricing
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

/* ---------- Helper Components ---------- */

const Stat = ({ value, label }) => (
  <div>
    <div className="text-4xl lg:text-5xl font-black mb-2">{value}</div>
    <div className="text-orange-100 font-medium">{label}</div>
  </div>
);

const CaseStudy = ({
  tag,
  title,
  image,
  stats,
  challenge,
  solution,
  results,
  quote,
  author,
}) => (
  <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
    <div className="relative h-64 lg:h-80">
      <img src={image} alt={title} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/50" />
      <div className="absolute bottom-0 p-8 text-white">
        <span className="px-4 py-2 bg-orange-500 rounded-full text-sm font-bold">
          {tag}
        </span>
        <h2 className="text-2xl lg:text-3xl font-bold mt-4">{title}</h2>
      </div>
    </div>

    <div className="p-8 lg:p-12 space-y-10">
      <div className="grid md:grid-cols-3 gap-6">
        {stats.map((stat, i) => {
          const Icon = stat.icon;
          return (
            <div key={i} className="bg-orange-50 rounded-2xl p-6 text-center">
              <Icon className="w-8 h-8 text-orange-500 mx-auto mb-3" />
              <div className="text-3xl font-black">{stat.value}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          );
        })}
      </div>

      <Section title="The Challenge" text={challenge} />
      <Section title="The Solution" text={solution} />

      <div>
        <h3 className="text-xl font-bold mb-3">The Results</h3>
        <ul className="grid md:grid-cols-2 gap-3 text-gray-600 list-disc pl-5">
          {results.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      </div>

      <div className="bg-gray-900 text-white rounded-2xl p-8">
        <Quote className="w-10 h-10 text-orange-400 mb-4" />
        <p className="italic mb-4">"{quote}"</p>
        <p className="text-orange-300 font-semibold">— {author}</p>
      </div>
    </div>
  </div>
);

const Section = ({ title, text }) => (
  <div>
    <h3 className="text-xl font-bold mb-3">{title}</h3>
    <p className="text-gray-600">{text}</p>
  </div>
);

export default CaseStudies;
